<template>
  <el-autocomplete
    v-model="tempValue"
    @select="selectSchool"
    :fetch-suggestions="querySearchAsync"
    placeholder="请输入"
    :icon="icon"
    :on-icon-click="clearInput"
    @blur="clearInput"
    :clearable="clearable"
  />
</template>

<script>
export default {
  name: 'JmSearch',
  props: {
    countryId: {
      type: [Number, String],
    },
    value: [Object, String],
    clearable: {
      type: Boolean,
      default: false,
    },
    getUrl: {
      type: String,
      default: null,
    },
    getList: {
      type: String,
      default: 'sh_name_cn'
    },
    shId: {
      type: [String, Number],
      default: null
    },
    getValue: {
      type: String,
      default: '',
    },
    getOtherValue: {
      type: [String, Array],
      default: null
    },
    getType: {
      type: String,
      default: '',
    },
    getotherType: {
      type: [String, Array],
      default: null
    },
    isDoble: {
      type: Boolean,
      default: false
    }
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      tempValue: null,
      tempSchool: [],
      returnData: {},
      firstRdata: {},
    };
  },
  computed: {
    icon() {
      return this.tempValue && this.clearable ? 'circle-close' : '';
    }
  },
  methods: {
    querySearchAsync(name, cb) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!name) {
          cb([]);
          this.selectSchool({});
          return false;
        }
        this.$http._get({
          url: this.getUrl,
          data: {
            countryId: this.countryId,
            sh_id: this.shId,
            name,
          }
        }).then(({ data }) => {
          const schoolData = Array.isArray(data) ? data : Object.values(data);
          let schools = [];
          this.tempSchool = schoolData;
          schoolData.forEach((item) => {
            item.value = item[this.getList];
            schools.push(item);
          });
          cb(schools);
        });
      }, 500);
    },
    selectSchool(val) {
      if (Object.keys(val).length > 0) {
        if (typeof this.getOtherValue === 'string') {
          this.value[this.getValue] = val[this.getType];
          this.value[this.getOtherValue] = val[this.getotherType];
        } else {
          this.value[this.getValue] = val[this.getType];
          if (this.getOtherValue) {
            this.getOtherValue.forEach((item, index) => {
              this.value[item] = val[this.getotherType[index]];
            });
          }
        }
      } else {
        if (this.isDoble) {
          this.value[this.getValue] = '';
          this.getOtherValue.forEach((item, index) => {
            if (val[this.getotherType[index]]) {
              this.value[item] = val[this.getotherType[index]];
            } else {
              this.value[item] = '';
            }
          });
        }
        this.value[this.getValue] = '';
      }
      this.$emit('change', this.value);
    },
    clearInput() {
      let schoolList = this.tempSchool;
      if (schoolList.length > 0 && this.tempValue) {
        let sameSchool = false;
        Object.keys(schoolList).forEach((i) => {
          if (schoolList[i].sh_name_cn === this.tempValue) {
            sameSchool = true;
            this.selectSchool(schoolList[i]);
          }
        });
        if (!sameSchool) {
          let school = {
            schoolname_en: this.tempValue,
            sh_country: 0,
            sh_id: 0,
            sh_mg_id: 0,
            sh_name_cn: this.tempValue,
            sh_name_en: this.tempValue,
            sh_name_ww: this.tempValue,
          };
          this.selectSchool(school);
        }
      }
    },
  },
  watch: {
    value: {
      handler: function (v) {
        this.tempValue = this.value[this.getValue];
        if (!v) {
          this.clearInput();
        }
      },
      deep: true
    },
    tempValue(v) {
      this.value[this.getValue] = v;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tempValue = this.value[this.getValue] === 0 ? null : this.value[this.getValue];
    });
  },
};
</script>
